// extracted by mini-css-extract-plugin
module.exports = {"container":"EventTimestamp_container__3zeDT","head":"EventTimestamp_head__qK4pO","tail":"EventTimestamp_tail__1yC0S","timestamp":"EventTimestamp_timestamp__2wk4K"};